import { useState, useContext } from "react";
import BorseContext from "../../context/borse";
import { downloadDocument, getFilenameDetails } from "../../utils/documents";
import Icon from "../icon";

const BorseAnnouncements = () => {
  const { labels, survey } = useContext(BorseContext);
  const [isDownloading, setIsDownloading] = useState(false);

  const download = async (doc) => {
    setIsDownloading(true);
    await downloadDocument(doc);
    setIsDownloading(false);
  };

  return (
    survey?.attachments?.length > 0 && (
      <div className="app-content__section">
        <ul className="table table--file">
          <li className="table__header">
            <div className="table__box table__box--title">
              {labels?.WELFARE_BORSE_ANNOUNCEMENTS || "Announcements"}
            </div>
          </li>
          <li className="table__item table__item--file-list">
            {survey?.attachments?.map((item) => (
              <button
                className="table__icon table__icon--download"
                type="button"
                key={item?.id}
                onClick={() => download(item)}
              >
                {isDownloading ? <span className="loading-spinner" /> : <Icon name="download" />}
                <span className="table__box">
                  {labels?.[
                    `WELFARE_BORSE_ATTACHMENT_${getFilenameDetails(
                      item?.fileName
                    )?.clearFilename.toUpperCase()}`
                  ] || getFilenameDetails(item?.fileName)?.clearFilename}{" "}
                  {`(${(labels?.WELFARE_BORSE_FILE_FORMAT || "[EXTENSION] format").replace(
                    "[EXTENSION]",
                    getFilenameDetails(item?.fileName)?.dotExtension
                  )})`}
                </span>
              </button>
            ))}
          </li>
        </ul>
      </div>
    )
  );
};

export default BorseAnnouncements;
